var map = {
	"./search-results-page.de-CH.json": 1301,
	"./search-results-page.de-DE.json": 1302,
	"./search-results-page.en-CA.json": 1303,
	"./search-results-page.en-GB.json": 1304,
	"./search-results-page.en-IN.json": 1305,
	"./search-results-page.en-ME.json": 1306,
	"./search-results-page.en-US.json": 1307,
	"./search-results-page.es-EM.json": 1308,
	"./search-results-page.es-ES.json": 1309,
	"./search-results-page.fr-BE.json": 1310,
	"./search-results-page.fr-CA.json": 1311,
	"./search-results-page.fr-CH.json": 1312,
	"./search-results-page.nl-BE.json": 1313,
	"./search-results-page.nl-NL.json": 1314,
	"./search-results-page.pl-PL.json": 1315,
	"./search-results-page.pt-BR.json": 1316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1300;